module.exports = __webpack_public_path__ + "931c108c08d9dbed5ef8799b2fef7b74.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-bold.ttf
// module id = 86
// module chunks = 0